import { render, staticRenderFns } from "./staffsList.vue?vue&type=template&id=b84bde40&scoped=true&"
import script from "./staffsList.vue?vue&type=script&lang=js&"
export * from "./staffsList.vue?vue&type=script&lang=js&"
import style0 from "./staffsList.vue?vue&type=style&index=0&id=b84bde40&lang=scss&scoped=true&"
import style1 from "./staffsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b84bde40",
  null
  
)

export default component.exports